<template>
    <b-dropdown
            v-if="showDropDown"
            right
            variant="background-white"
            class="d-flex align-items-center ms-3 ms-lg-4"
            menu-class="pl-0"
          >
            <template #button-content>
              <div
                class="btn btn-icon btn-primary position-relative w-30px h-30px w-lg-40px h-lg-40px"
                id="kt_drawer_chat_toggle"
              >
                {{ unSeenNotifications }}
                <!--begin::Bullet-->
                <span
                  class="d-none bullet bullet-dot bg-danger h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink"
                ></span>
                <!--end::Bullet-->
              </div>
            </template>
            <div class="_dropdown-items">
              <b-dropdown-item-btn
                @click="viewBarrel(notification,$event)"
                v-for="notification in displayedNotifications"
                :key="notification.Id"
              >
                <template #default>
                  <span
                    :class="{ 'text-green': notification.Seen }"
                  >
                    <v-progress-circular class="mr-2" v-if="processingCurrentNotif(notification.Id)" size="10" width="1" indeterminate></v-progress-circular>
                    <v-icon
                      v-if="notification.Seen"
                      class="pr-2"
                      small
                    >mdi-blank</v-icon>
                    <v-tooltip left v-if="!notification.Seen && !processingCurrentNotif(notification.Id)">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="pr-2"
                          v-bind="attrs"
                          v-on="on"
                          small
                          @click="markSeen(notification.Id,$event)"
                        >mdi-eye-outline</v-icon>
                      </template>
                      <span>Mark As Seen</span>
                    </v-tooltip>
                    [{{ notification.date }}] {{ notification.Title }}
                  </span>
                  >
                </template>
              </b-dropdown-item-btn>
            </div>
            <div>
               <b-dropdown-divider></b-dropdown-divider>
              <v-row align="center">
                <v-col cols="1" class="ml-3 py-0">
                  <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon :color="seeAllIconColor">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            x-small
                            @click="filterNotif('all',$event)"
                          >mdi-all-inclusive</v-icon>
                        </v-btn>
                      </template>
                      <span>View all</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="1" class="py-0">
                  <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon :color="seenIconColor">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            x-small
                            @click="filterNotif('seen',$event)"
                          >mdi-eye-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>View Seen</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="1" class="py-0">
                  <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon :color="unseenIconColor">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            x-small
                            @click="filterNotif('unseen',$event)"
                          >mdi-eye-off-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>View Unseen</span>
                    </v-tooltip>
                </v-col>
                <v-col></v-col>
                <v-col cols="5" class="pr-0 py-0" v-if="displayedNotifications.length">
                  <v-btn v-if="!markAllSeenLoading && !allNotificationSeen" small @click="markAllSeen($event)" color="#0A31A2" text>Mark All Seen</v-btn>
                  <v-progress-circular v-if="markAllSeenLoading" size="20" width="1" color="#0A31A2" indeterminate></v-progress-circular>
                </v-col>
              </v-row>
            </div>
          </b-dropdown>
</template>

<script>
import dayjs from "dayjs";
import { ApiService } from "@/services/ApiService";
import mixins from "vue-typed-mixins";
import UserMixin from "@/mixins/UserMixin";
import ScreenMixin from "@/mixins/ScreenMixin";
import { error } from "@/services/LoggerService";


export default mixins(ScreenMixin, UserMixin).extend({
    props: {
        reload: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            notifications: [],
            filter: "all",
            selectedNotification: '',
            markSeenLoading: false,
            markAllSeenLoading: false,
            selectedColor: 'rgb(0, 150, 255)' //bright blue
        }
    },
    watch: {
        async reload(){
            if(this.reload === true){
                if(this.isCustomer && this.isStaff){
                setTimeout(async()=>{
                    await this.getNotifications();
                }, 1000)
                }
                this.$emit('reset');
            }
        }
    },
    computed: {
        showDropDown() {
            return this.signedIn && this.isCustomer
        },
        allNotificationSeen(){
            return this.displayedNotifications.every(notif => notif.Seen);
        },
        seeAllIconColor(){
            return this.filter === 'all' ? this.selectedColor :''
        },
        seenIconColor(){
            return this.filter === 'seen' ? this.selectedColor :''
        },
        unseenIconColor(){
            return this.filter === 'unseen' ? this.selectedColor :''
        },
        displayedNotifications() {
            if (!this.notifications) return this.notifications;
            if (this.filter == "seen")
                return this.notifications.filter((x) => x.Seen);
            if (this.filter == "unseen")
                return this.notifications.filter((x) => !x.Seen);
            return this.notifications;
        },
        unSeenNotifications() {
            return this.notifications.filter((n) => {
                return !n.Seen;
            }).length;
        }
    },
    methods: {
        processingCurrentNotif(notificationId){
            if(this.markAllSeenLoading) return true;
            return this.markSeenLoading && this.notifIdMatch(notificationId);
        },
        notifIdMatch(notifId){
            return notifId === this.selectedNotification;
        },
        handleViewOperation(notification){
            const {BarrelId,NotificationType:type} = notification;

            const routeBarrelId = this.$route.params.barrelId;
            if(type === 'Unpacked Item Received'){
                if(window.location.pathname.toLowerCase().includes('mybarrels')){
                const customerUnpackedItemHeader = document.getElementById('customerUnpackedItemHeader');
                if(!customerUnpackedItemHeader.className.includes('active')) customerUnpackedItemHeader.click();
                setTimeout(() => {
                    window.location.href = '#customerUnpackedItemHeader';
                }, 500)
                return;
                }
                this.$router.push({name: "MyBarrels",
                params: {
                    openNotpackedTable: true
                }
                });
                return;
            }

            if(routeBarrelId && routeBarrelId === BarrelId){
                this.$emit('showNotifier',{
                message: 'Currently viewing barrel',
                snackbarType: 'info'
                })
                return;
            }

            if(BarrelId){
                const prevBarrelId = window.sessionStorage.getItem('id');
                const detailsPage = window.location.pathname.includes('/details/');
                this.$router.push({
                name: "Details",
                params: { barrelId: BarrelId },
                });
                // this reload is here because when on the details page of one barrel and try
                // navigating to another barrel notifcation it would only update the url but the
                // barrel information already on the page does not update
                if(detailsPage && prevBarrelId !== BarrelId) location.reload();
                return;
            }
        },
        async markAllSeen(event){
            try{
                this.markAllSeenLoading = true;
                event.stopPropagation();
                const response = await Promise.all(this.notifications.map(async(notif) => {
                if(notif.Seen) return true;
                return await this.markNotificationSeen(notif.Id);
                }))

                let showNotifierInput =
                (response.every(res => res === true))
                ? {
                    message: `Successfully Marked All As Seen`,
                    snackbarType: "success",
                }
                : (response.every(res => res === false))
                ? {
                    message: `All Failed To Be Marked As Seen`,
                    snackbarType: "error",
                }
                : {
                    message: `Some Failed To Be Marked As Seen`,
                    color: 'rgb(255, 255, 143)' //Canary Yellow
                }

                if(showNotifierInput.message) this.$emit('showNotifier',showNotifierInput);

                this.$nextTick(async () => {
                await this.getNotifications();
                this.markAllSeenLoading = false;
                });
            }
            catch(err){
                this.markAllSeenLoading = false;
                error(err)
            }
        },
        async markSeen(notificationId,event){
            try{
                this.selectedNotification = notificationId;
                this.markSeenLoading = true;
                event.stopPropagation();
                const marked = await this.markNotificationSeen(notificationId);
                if(marked){
                this.$emit('showNotifier',{
                    message: `Successfully Marked As Seen`,
                    snackbarType: "success"
                })
                this.$nextTick(async () => {
                    await this.getNotifications();
                    this.markSeenLoading = false;
                });
                }
            }
            catch(err){
                this.markSeenLoading = false;
                error(err);
            }
        },
        async viewBarrel(notification,event) {
            try {
                this.handleViewOperation(notification);
                const {Id: notifId,Seen} = notification;
                if(!Seen) await this.markSeen(notifId,event);
            } catch (e) {
                error(e);
            }
        },
        filterNotif(filter,event){
            this.filter=filter;
            event.stopPropagation();
        },
        async markNotificationSeen(notificationId){
            return await ApiService.Instance.markNotificationSeen(
                notificationId
            );
        },
        async getNotifications() {
            try {
                let result = await ApiService.Instance.getNotifications();
                result.forEach((notification) => {
                notification.date = this.formatDate(notification.Date);
                });
                result.sort(function (a, b) {
                return new Date(b.Date) - new Date(a.Date);
                });
                this.notifications = result;
            } catch (e) {
                error(e);
            }
        },
        formatDate(date) {
            return dayjs(date).format("MMM D");
        },
    },
    async beforeMount() {
        try {
        if(this.signedIn) await this.getNotifications();
        } catch (e) {
        error(e);
        }
    },
});
</script>

<style lang="scss" scoped>
._dropdown-items{
  overflow: scroll;
  max-height: 70vh;
}
</style>